import { axios } from '@/utils/request'

export default{
  get(id){
    return axios.get('/api/services/app/WechatMsg/Get?Id='+id)
  },
  getAll(page){
    return axios.get('/api/services/app/WechatMsg/GetAll',{params:page})
  },
  create(input){
    return axios.post('/api/services/app/WechatMsg/Create',input)
  },
  update(input){
    return axios.put('/api/services/app/WechatMsg/Update',input)
  },
  delete(id){
    return axios.delete('/api/services/app/WechatMsg/Delete?Id='+id)
  }
}